<p-button
  [class]="sizeClass + (active ? ' active' : '')"
  [severity]="severity"
  [disabled]="disabled"
  [rounded]="rounded"
  [text]="textButton"
  [outlined]="outlinedButton"
  [icon]="iconOnlyButton ? icon : undefined"
  (onClick)="btnClick.emit()"
>
  @if (!iconOnlyButton) {
    <div class="flex align-items-center gap-spacing-default">
      @if (iconStart) {
        <i
          [ngClass]="{ spin: isLoading }"
          [class]="iconStart + ' p-button-icon me-0 text-base'"
        ></i>
      }

      @if (label) {
        <span class="p-button-label white-space-nowrap">{{ label }}</span>
      }

      @if (iconEnd) {
        <i [class]="iconEnd + ' p-button-icon me-0'"></i>
      }
    </div>
  }
</p-button>
